import styled from 'styled-components';

export const SearchInputStyled = styled.div`
    position: relative;
`;

export const BtnWrapperStyled = styled.div`
    position: absolute;
    top: 0;
    right: 2px;
    display: flex;
    align-items: center;
    height: 100%;
    > * {
        background-color: ${({ theme }) => theme.branding.white.lighter};
        border-radius: ${({ theme }) => theme.defaults.borderRadius};
        border-color: transparent;
    }
`;
